import {connect} from 'react-redux';
import * as React from "react";
import GroupAdminState, {ContractGroup} from "../GroupAdminState";
import * as selectors from "../selectors";
import {
    createContractGroup,
    CreateContractGroup,
    deleteContractGroup,
    DeleteContractGroup,
    getContractGroups,
    GetContractGroups,
    renameContractGroup,
    RenameContractGroup,
    setSelectedContractGroup,
    SetSelectedContractGroup
} from "../actions";
import {Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle} from 'react-bootstrap';


interface ComponentState {
    showRenameGroupModal: boolean;
    showDeleteGroupModal: boolean;
    showNewGroupModal: boolean;
}

interface TagProps {

}

interface StateProps {
    contractGroups: ContractGroup[],
    selectedContractGroup: ContractGroup,
    selectedContractGroupId: string,
    canCreateGroups: boolean,
}

interface DispatchProps {
    doSetSelectedContractGroup: SetSelectedContractGroup,
    doRenameContractGroup: RenameContractGroup,
    doDeleteContractGroup: DeleteContractGroup,
    doCreateContractGroup: CreateContractGroup,
    doGetContractGroups: GetContractGroups,
}

const mapStateToProps = (state: GroupAdminState): StateProps => {
    return {
        contractGroups: selectors.contractGroups(state),
        selectedContractGroup: selectors.selectedContractGroup(state),
        selectedContractGroupId: selectors.selectedContractGroupId(state),
        canCreateGroups: selectors.userCanCreateGroups(state),
    };
};

const mapDispatchToProps: DispatchProps = ({
    doSetSelectedContractGroup: setSelectedContractGroup,
    doRenameContractGroup: renameContractGroup,
    doDeleteContractGroup: deleteContractGroup,
    doCreateContractGroup: createContractGroup,
    doGetContractGroups: getContractGroups,
});

type Props = TagProps & StateProps & DispatchProps;
type CompareType = (a: ContractGroup, b: ContractGroup) => number;

const compareContractGroupNames = (intlCollator: Intl.Collator): CompareType => {
    return function compareWithIntlCollator(a: ContractGroup, b: ContractGroup): number {
        return intlCollator.compare(a.name, b.name);
    }
}

const sortGroups = (contractGroups: ContractGroup[], intlCollator: Intl.Collator): ContractGroup[] => {
    // Sorts contractGroups inplace
    contractGroups.sort(compareContractGroupNames(intlCollator));
    return contractGroups;
}

class GroupSelectorComponent extends React.Component<Props, ComponentState> {

    private updatedGroupName: HTMLInputElement;
    private newGroupName: HTMLInputElement;

    constructor(props: Props) {
        super(props);
        this.state = {
            showRenameGroupModal: false,
            showDeleteGroupModal: false,
            showNewGroupModal: false
        };
    }


    render() {

        let {contractGroups, canCreateGroups, selectedContractGroupId} = this.props;
        let intlCollator = Intl.Collator('nb', {numeric: true});

        return (

            <div className="groupSelector">
                <select className="groupSelector--select" onChange={(e) => this.handleContractGroupChange(e)}
                        value={selectedContractGroupId}>
                    {sortGroups(contractGroups, intlCollator).map(group => {
                        return (
                            <option value={group.id} key={group.id}>{group.name}</option>
                        )
                    })}
                </select>

                <Button className="glyphicon glyphicon-pencil groupSelector--button"
                        title="Endre navn"
                        onClick={(e) => this.showRenameGroupModal()}
                />

                <Button className="glyphicon glyphicon-trash groupSelector--button"
                        title="Slett"
                        onClick={(e) => this.showDeleteGroupModal()}
                />

                {canCreateGroups &&
                <Button className="groupSelector--button groupSelector--new" onClick={() => this.showNewGroupModal()}>Ny
                    kontraktgruppe</Button>
                }

                {this.state.showRenameGroupModal &&
                <Modal show={true} onHide={() => this.closeRenameGroupModal()}>
                    <ModalHeader>
                        <ModalTitle>Endre navn på kontraktgruppe</ModalTitle>
                    </ModalHeader>
                    <form>
                        <ModalBody>
                            <label>Velg nytt navn:</label>
                            <br/>
                            <input defaultValue={this.props.selectedContractGroup.name} type="text"
                                   placeholder={"Min kontraktgruppe"} autoFocus={true}
                                   ref={(input) => this.updatedGroupName = input}
                                   className={"contractgroup-name-input"}/>
                        </ModalBody>
                        <ModalFooter>
                            <Button bsStyle="default" onClick={() => this.closeRenameGroupModal()}>Avbryt</Button>
                            <Button bsStyle="primary" type="submit"
                                    onClick={() => this.handleRenameContractGroupClick()}>OK</Button>
                        </ModalFooter>
                    </form>
                </Modal>
                }

                {this.state.showDeleteGroupModal &&
                <Modal show={true} onHide={() => this.closeDeleteGroupModal()}>
                    <ModalHeader>
                        <ModalTitle>Slette kontraktgruppe</ModalTitle>
                    </ModalHeader>
                    <form>
                        <ModalBody>
                            <p>{this.getDeleteContractGroupText()}</p>
                            <p>Er du sikker på at du vil slette kontraktgruppa?</p>
                        </ModalBody>
                        <ModalFooter>
                            <Button bsStyle="default" onClick={() => this.closeDeleteGroupModal()}>Avbryt</Button>
                            <Button bsStyle="primary" type="submit"
                                    onClick={() => this.handleDeleteContractGroupClick()}>OK</Button>
                        </ModalFooter>
                    </form>
                </Modal>
                }

                {this.state.showNewGroupModal &&
                <Modal show={true} onHide={() => this.closeNewGroupModal()}>
                    <ModalHeader>
                        <ModalTitle>Opprett ny kontraktgruppe</ModalTitle>
                    </ModalHeader>
                    <form onSubmit={e => e.preventDefault()}>
                        <ModalBody>
                            <input type="text" placeholder={"Min kontraktgruppe"} autoFocus={true}
                                   ref={(input) => this.newGroupName = input} className={"contractgroup-name-input"}/>
                        </ModalBody>
                        <ModalFooter>
                            <Button bsStyle="default" onClick={() => this.closeNewGroupModal()}>Avbryt</Button>
                            <Button bsStyle="primary" type="submit"
                                    onClick={() => this.handleCreateNewGroupClick()}>OK</Button>
                        </ModalFooter>
                    </form>
                </Modal>
                }

            </div>
        );
    }

    handleContractGroupChange = function (event: React.ChangeEvent<HTMLSelectElement>) {
        this.props.doSetSelectedContractGroup(event.target.value);
    };

    showRenameGroupModal = function () {
        this.setState({
            showRenameGroupModal: true
        })
    }

    closeRenameGroupModal = function () {
        this.setState({
            showRenameGroupModal: false
        })
    }

    handleRenameContractGroupClick = function () {
        event.preventDefault();
        this.props.doRenameContractGroup(this.props.selectedContractGroup.id, this.updatedGroupName.value);
        this.closeRenameGroupModal();
    }.bind(this);

    showDeleteGroupModal = function () {
        this.setState({
            showDeleteGroupModal: true
        })
    }

    closeDeleteGroupModal = function () {
        this.setState({
            showDeleteGroupModal: false
        })
    }

    handleDeleteContractGroupClick = function () {
        event.preventDefault();
        this.props.doDeleteContractGroup(this.props.selectedContractGroup.id);
        this.closeDeleteGroupModal();
    }.bind(this);

    showNewGroupModal = function () {
        this.setState({
            showNewGroupModal: true
        })
    };

    closeNewGroupModal = function () {
        this.setState({
            showNewGroupModal: false
        })
    };

    handleCreateNewGroupClick = function () {
        event.preventDefault();
        this.props.doCreateContractGroup(this.newGroupName.value);
        this.closeNewGroupModal();
    }.bind(this);

    getDeleteContractGroupText = function () {
        let contractGroupName = this.props.selectedContractGroup.name;
        let numberOfContracts = this.props.selectedContractGroup.contracts.length;
        let numberOfUsers = this.props.selectedContractGroup.users.length;

        let returnString = "";

        if (numberOfContracts > 0 || numberOfUsers > 0) {
            returnString += "Kontraktgruppa \"" + contractGroupName + "\" er tilknyttet ";
        }
        if (numberOfContracts > 0 && numberOfUsers > 0) {
            returnString += this.getNumberOfContractsString(numberOfContracts) + " og " + this.getNumberOfUsersString(numberOfUsers) + ".";
        }
        if (numberOfContracts > 0 && numberOfUsers === 0) {
            returnString += this.getNumberOfContractsString(numberOfContracts) + ".";
        }
        if (numberOfContracts === 0 && numberOfUsers > 0) {
            returnString += this.getNumberOfUsersString(numberOfUsers) + ".";
        }
        return returnString;
    }

    getNumberOfContractsString = function (numberOfContracts: number): string {
        let plural: boolean = numberOfContracts != 1;
        return numberOfContracts + " kontrakt" + (plural ? "er" : "");
    }

    getNumberOfUsersString = function (numberOfUsers: number): string {
        let plural: boolean = numberOfUsers != 1;
        return numberOfUsers + " bruker" + (plural ? "e" : "");
    }

}

export const GroupSelector = connect(mapStateToProps, mapDispatchToProps)(GroupSelectorComponent);
